"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HeatmapOptions = /** @class */ (function () {
    function HeatmapOptions() {
        this.itemSizeX = 18;
        this.itemSizeY = 18;
        this.color = ['rgb(30, 30, 30)', "#30c4c4", "#008d8d", "#0fb5b5", "#53d4d4", "#83e5e5"];
        this.data = Promise.resolve([]);
        this.colorGroup = "auto";
    }
    return HeatmapOptions;
}());
exports.default = HeatmapOptions;
